module.exports = __webpack_public_path__ + "static/img/ecg_green_btm_new.397b32c7.png";